import { defineMessages } from "react-intl";

export const messages = defineMessages({
  submit: "Submit & get results",
  skip: "No thanks",
  emailTitle: "Almost there!",
  emailSubtext: "Fill in your email to get the results. We’ll only use your email for relevant product information.",
  emailLabel: "Your email",
  emailPlaceholder: "Email address",
  nameLabel: "Your first name",
  namePlaceholder: "First Name",
  nameRequired: "Please fill in your name to continue",
  emailRequired: "Please fill in your email to continue",
  phoneRequired: "Please fill in your phone number to continue",
  answerRequired: "Select an answer to continue",
  finish: "Finish",
  next: "Next question",
});
